var map = {
	"./beer.png": 470,
	"./billaactive.png": 813,
	"./billalogo.png": 669,
	"./billapassive.png": 88,
	"./ffactive.png": 631,
	"./fflogo.png": 612,
	"./ffpassive.png": 191,
	"./flamelv.png": 643,
	"./flamepercent.png": 324,
	"./kauflandactive.png": 792,
	"./kauflandlogo.png": 505,
	"./kauflandlogohor.png": 704,
	"./kauflandpassive.png": 7,
	"./lidlactive.png": 763,
	"./lidllogo.png": 684,
	"./lidlpassive.png": 390,
	"./other.png": 620,
	"./rakia.png": 159,
	"./title.png": 187,
	"./titleinfo.png": 774,
	"./titlemobile.png": 838,
	"./titlemobileorange.png": 500,
	"./titleorange.png": 487,
	"./tmarketactive.png": 991,
	"./tmarketlogo.png": 856,
	"./tmarketpassive.png": 864,
	"./vino.png": 336,
	"./vodka.png": 851,
	"./whiskey.png": 4
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;